import { getLocale } from "../runtime";

const sv_iconremove = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ta bort`
};

const iconremove = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_iconremove(inputs)
	return "iconRemove";
};

export { iconremove as "iconRemove" };